import { Link } from "react-router-dom";
import PageHeader from "../header";
import { useLanguage } from "../../context/LanguageProvider";
import "../../style/errorPage.css";

export const SUPPORT_EMAIL = "info@ar-rows.com";

/**
 * Minimal full-page error shell shared by every 403/404 surface.
 *
 * Rendered in place — these pages never redirect to a /403 or /404 URL, so the address bar keeps
 * the link the learner actually followed (and a refresh re-checks access).
 *
 * @param {string} code Big status number ("403" / "404").
 * @param {Array<{key: string, label: React.ReactNode, to?: string, onClick?: Function, variant?: "primary"|"secondary"}>} actions
 */
const ErrorPage = ({ code, title, message, details, actions = [] }) => {
  const { dir } = useLanguage();

  return (
    <div className="error-page-wrap">
      <PageHeader />
      <main className={`error-page ${dir}`} dir={dir} role="alert">
        <div className="error-page__card">
          <div className="error-page__code" aria-hidden="true">
            {code}
          </div>
          <h1 className="error-page__title">{title}</h1>
          {message ? <p className="error-page__message">{message}</p> : null}
          {details ? <div className="error-page__details">{details}</div> : null}
          {actions.length ? (
            <div className="error-page__actions">
              {actions.map(({ key, label, to, onClick, variant = "secondary" }) =>
                to ? (
                  <Link key={key} to={to} className={`error-page__action error-page__action--${variant}`}>
                    {label}
                  </Link>
                ) : (
                  <button
                    key={key}
                    type="button"
                    onClick={onClick}
                    className={`error-page__action error-page__action--${variant}`}
                  >
                    {label}
                  </button>
                )
              )}
            </div>
          ) : null}
        </div>
      </main>
    </div>
  );
};

export default ErrorPage;
